export default __webpack_public_path__ + "static/4dayweek-0b45af043062a41ad63dc0e1ea13c97a.png";